import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMain,[_c('core-warnings'),_c('core-toolbar'),_c('core-drawer'),_c('div',{attrs:{"id":"core-view"}},[_c('router-view',{key:_vm.$route.path})],1),_c('helper-suspended')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }